import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircle from '@mui/icons-material/CheckCircle';
import { Switch as MuiSwitch, Stack, SwitchProps, Typography } from '@mui/material';

import { iconGrey } from '@/theme';

export const Switch = ({ readOnly, ...props }: SwitchProps & { readOnly?: boolean }) => {
    if (readOnly) {
        return (
            <Stack direction="row" className="readOnly" sx={{ alignItems: 'center', gap: 0.5 }}>
                {props.checked ? (
                    <>
                        <CheckCircle color={'info'} fontSize="small" />
                        <Typography sx={{ lineHeight: 1 }}>On</Typography>
                    </>
                ) : (
                    <>
                        <CancelIcon sx={{ fill: iconGrey }} fontSize="small" />
                        <Typography sx={{ lineHeight: 1 }}>Off</Typography>
                    </>
                )}
            </Stack>
        );
    }
    return <MuiSwitch {...props} />;
};
